import BaseModel from '@launchpad/logic/model/BaseModel';

export default class AuthorisationImportFileRowModel extends BaseModel {
  /**
   * Get Method
   */
  getMethod(): string {
    return 'GET';
  }

  /**
   * Get list url
   */
  getListUrl(params: any): any {
    return `admin/temenos/authorisation-import/files/${params.id}/rows`;
  }

  /**
   * Get default table columns
   */
  getTableColumns(): any {
    return [
      {
        name: 'id',
        label: 'Id',
        sortable: false,
        type: 'field',
      },
      {
        name: 'rowIndex',
        label: 'Row Index',
        sortable: false,
        type: 'field',
      },
      {
        name: 'payload.USER_ID',
        label: 'User Id',
        sortable: false,
        type: 'field',
      },
      {
        name: 'paymentDeviceId',
        label: 'Payment Device Id',
        sortable: false,
        type: 'field',
      },
      {
        name: 'payload.PAYMENT_DEVICE_PAN',
        label: 'Payment Device Pan',
        sortable: false,
        type: 'field',
      },
      {
        name: 'payload.ACCOUNT_NUMBER',
        label: 'Account Number',
        sortable: false,
        type: 'field',
      },
      {
        name: 'status',
        label: 'Status',
        sortable: false,
        type: 'field',
      },
      {
        name: null,
        label: 'Actions',
        sortable: false,
        type: 'actions',
      },
    ];
  }
}
